import { useState } from 'react';

function HomeContent() {
  return <></>;
}

export default HomeContent;
